/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrInviteResponse
 */
export interface RttrInviteResponse {
    /**
     * 
     * @type {number}
     * @memberof RttrInviteResponse
     */
    pointsAwarded: number;
    /**
     * 
     * @type {number}
     * @memberof RttrInviteResponse
     */
    segmentIndex: number;
    /**
     * Combined code-signup referrals + email invites counted against this round's cap of 3, after this invite.
     * @type {number}
     * @memberof RttrInviteResponse
     */
    referralsUsedThisRound: number;
}

/**
 * Check if a given object implements the RttrInviteResponse interface.
 */
export function instanceOfRttrInviteResponse(value: object): value is RttrInviteResponse {
    if (!('pointsAwarded' in value) || value['pointsAwarded'] === undefined) return false;
    if (!('segmentIndex' in value) || value['segmentIndex'] === undefined) return false;
    if (!('referralsUsedThisRound' in value) || value['referralsUsedThisRound'] === undefined) return false;
    return true;
}

export function RttrInviteResponseFromJSON(json: any): RttrInviteResponse {
    return RttrInviteResponseFromJSONTyped(json, false);
}

export function RttrInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsAwarded': json['pointsAwarded'],
        'segmentIndex': json['segmentIndex'],
        'referralsUsedThisRound': json['referralsUsedThisRound'],
    };
}

export function RttrInviteResponseToJSON(json: any): RttrInviteResponse {
    return RttrInviteResponseToJSONTyped(json, false);
}

export function RttrInviteResponseToJSONTyped(value?: RttrInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsAwarded': value['pointsAwarded'],
        'segmentIndex': value['segmentIndex'],
        'referralsUsedThisRound': value['referralsUsedThisRound'],
    };
}

